import { useQuery, useQueryClient, useMutation } from "react-query";
import { makeAuthedRequest } from "utils/makeAuthedRequest";

export function useHomeSite() {
  const queryClient = useQueryClient();

  //Homesites GET
  const { data, status, error, isLoading, refetch } = useQuery(
    ["homesites"],
    () =>
      makeAuthedRequest(`v1/events/homesites`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error((await res.json()).message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  //Homesites POST
  const addHomesite = useMutation(
    (homesiteData) =>
      makeAuthedRequest(`v1/events/homesite-add`, {
        method: "POST",
        body: JSON.stringify(homesiteData),
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("homesite-add");
      },
      onError: (err) => {
        console.error(err);
      },
    }
  );

  return {
    isLoading,
    status,
    data,
    error,
    addHomesite,
    refetch,
  };
}

//User Info
export function useUsersInfo() {
  const { data, isLoading, refetch } = useQuery(
    ["usersInfo"],
    () =>
      makeAuthedRequest("v1/settings/ibo/users", {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error((await res.json()).message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}